import * as React from 'react';
import { Route, Switch } from 'react-router';
import NoMatch from '../404Old';
import FritidsSide from './fritid/Fritid';

export const Fritid: React.FC = () => {
  return (
    <>
      <Switch>
        <Route
          exact
          path="/selge-fritidseiendom-hytte"
          component={FritidsSide}
        />
        <Route component={NoMatch} />
      </Switch>
    </>
  );
};

export default Fritid;
